module.exports = __webpack_public_path__ + "static/media/wallet.689d3b9b.svg";